import { data } from '../../svg/AvgTime/data';
import { makeIcon } from '../makeIcon';

export const AvgTime = makeIcon(data, 'avg_time', 'AvgTime');

export default AvgTime;
